// /src/utils/facebookPixel.ts

declare global {
  interface Window {
    fbq: any;
  }
}

export function initPixel(){
    window.fbq('init', '678089589311638');
}

export function trackPageView(){
    window.fbq('track', 'PageView');
}

export function trackPurchase(value: number, currency: string, content_type:string, contentData:any) {
  console.log(value, currency, content_type, contentData);
  window.fbq("track", "Purchase", {
    value:value,
    currency:currency,
    content_type:content_type,
    content:contentData
  });
}

export function trackProceedPay(){
    window.fbq('track', 'Proceed To Order');
    window.clevertap.event.push('Proceed To Order');
    window.dataLayer.push({'event': 'Proceed To Order'});
}
